import { render, staticRenderFns } from "./GitlabRedirectPage.vue?vue&type=template&id=39217564&scoped=true&"
import script from "./GitlabRedirectPage.vue?vue&type=script&lang=js&"
export * from "./GitlabRedirectPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39217564",
  null
  
)

export default component.exports